module.exports = __webpack_public_path__ + "img/all-events-2.6127eef6.jpg";